export default {"src":"/_next/static/media/download-colearn.4b154816.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};